module.exports = __webpack_public_path__ + "img/D21.47da9fcf.jpg";